/**
 * @generated SignedSource<<d04c50c6817101d7b4a128591b91c8b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditMainTerms_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TermsSelect_data">;
  readonly " $fragmentType": "PackageEditMainTerms_data";
};
export type PackageEditMainTerms_data$key = {
  readonly " $data"?: PackageEditMainTerms_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditMainTerms_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditMainTerms_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TermsSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3bfd2f1477ed26b6013e39edfd00ba53";

export default node;
